<template>
  <div class="VipUpgradePanel">

    <div class="company-panel common-panel">
      <div class="panel-header">
        <div class="company-name">企业VIP</div>
        <div class="company-status" :class="{ 'ON': companyVipState == 1 }">
          <i class="icon"></i>
          <span class="company-status-txt">
            帐号{{ companyVipState == 1 ? '已' : '未' }}获得企业商用授权
          </span>
        </div>
        <div class="company-buy-btn">

          <!-- 企业VIP -->
          <template v-if="companyVipState == 1">
            <a
              v-if="companyVipState == 1"
              @click="tag('充值:详情页授权提示:图片:click')"
              :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY_VIP.RESALE"
              target="_blank">购买授权</a>
            <a v-else
               :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE"
               @click="tag('充值:详情页授权提示:图片:click')"
               target="_blank">升级授权</a>
          </template>
          <!-- 商用VIP / 个人VIP-->
          <template v-if="businessVipState == 1 || personVipState == 1">


            <a v-if="(businessVipState == 1 && personVipState == 1)"
               :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE + '/2-'+ VIP_MANAGE.COMPANY.All_PURPOSE_NEW.ID"
               @click="tag('充值:详情页授权提示:图片:click')"
               target="_blank">升级授权</a>

            <a v-if="(businessVipState == 1 && personVipState != 1)"
               :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE + '/2-'+ VIP_MANAGE.COMPANY.All_PURPOSE_NEW.ID"
               @click="tag('充值:详情页授权提示:图片:click')"
               target="_blank">升级授权</a>

            <a v-if="(businessVipState != 1 && personVipState == 1)"
               :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE + '/1-'+ VIP_MANAGE.COMPANY.All_PURPOSE_NEW.ID"
               @click="tag('充值:详情页授权提示:图片:click')"
               target="_blank">升级授权</a>


          </template>

          <!-- 非VIP -->
          <template v-if="businessVipState != 1 && personVipState != 1 && companyVipState != 1 ">
            <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY"
               @click="tag('充值:详情页授权提示:图片:click')"
               target="_blank">购买授权</a>
          </template>


        </div>
      </div>
      <div class="panel-content">
        <div class="company-equity">
          <div class="equity-item" v-for="(vo,index) in TUPIAN_DETAIL.COMPANY_EQUITY.LIST">
            <i :class="[ 'iconfont', companyEquityList[index] ? 'icon-gou21' : 'iconfont2 icon-qy-error-circle-fill' ]"
            ></i>
            {{ vo }}
          </div>
        </div>

      </div>

    </div>
    <div class="business-panel common-panel" v-if="companyVipState != 1">
      <div class="panel-header">
        <div class="company-name">商用VIP</div>
        <div class="company-status" :class="{ 'ON': businessVipState == 1 }">
          <i class="icon"></i>
          <span class="company-status-txt">
            帐号{{ businessVipState == 1 ? '已' : '未' }}获得个人商用授权
          </span>
        </div>
        <div class="company-buy-btn">
          <!--  仅商用 -->
          <!--  商用普通 -->
          <a
            v-if="(businessVipState == 1 && personVipState != 1) || businessVipState == 1 && personVipState == 1"
            :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE + '/2-'+ VIP_MANAGE.COMPANY.All_PURPOSE_NEW.ID"
            @click="tag('充值:详情页授权提示:图片:click')"
            target="_blank">升级授权</a>
          <!--  仅普通 -->
          <a
            v-if="businessVipState != 1 && personVipState == 1"
            :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.UPGRADE + '/1-'+ VIP_MANAGE.BUSINESS.YEAR.ID"
            @click="tag('充值:详情页授权提示:图片:click')"
            target="_blank">升级授权</a>

          <!--  非VIP -->
          <a
            v-if="businessVipState != 1 && personVipState != 1"
            :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS"
            @click="tag('充值:详情页授权提示:图片:click')"
            target="_blank">购买授权</a>
        </div>
      </div>
      <div class="panel-content">
        <div class="company-equity">
          <div class="equity-item" v-for="vo in TUPIAN_DETAIL.BUSINESS_EQUITY.LIST">
            <i :class="[ 'iconfont', businessVipState == 1 ? 'icon-gou21' : 'iconfont2 icon-qy-error-circle-fill' ]"
            ></i>
            {{ vo }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {VIP_EQUITY_LIST} from "@/components/pay/id/module";
import {TUPIAN_DETAIL} from "@/constant/tupian/TUPIAN_DETAIL";
import {PAGE_PATH} from '@/constant/PAGE_PATH'
import {tag} from "@/utils/statUtil";
import { VIP_MANAGE } from '@/constant/VIP_MANAGE'

export default {
  name: "VipUpgradePanel",
  computed: {
    ...mapState('user',
      [
        'personVipState',
        'personVipInfo',
        'businessVipState',
        'businessVipInfo',
        'companyVipState',
        'companyVipInfo',
        'isLogin',
        'downloadCount',
        'companyInfoByPerson',
        'uniq_id',
        'isSwitchAccountType',
        'isSwitchCompanyMain',
      ]
    ),
  },
  data() {
    return {
      VIP_EQUITY_LIST,
      TUPIAN_DETAIL,
      companyEquityList: [],
      PAGE_PATH,
      VIP_MANAGE
    }
  },
  watch: {
    /* 登录更新详情收藏 */
    isLogin(n, o) {
      if (n == true || n == false) {
        this.getCompanyEquityList();
      }
    },
    isSwitchAccountType: {
      handler(n, o) {
        setTimeout(() => {
          this.getCompanyEquityList();
        }, 500)
      }
    },
    isSwitchCompanyMain: {
      handler(n, o) {
        setTimeout(() => {
          this.getCompanyEquityList();
        }, 500)
      }
    },
  },
  mounted() {
    this.getCompanyEquityList();
  },
  methods: {
    getCompanyEquityList() {
      if (this.companyVipState == 1) {
        this.companyEquityList = this.TUPIAN_DETAIL.COMPANY_EQUITY[this.companyVipInfo.type]
      } else {
        this.companyEquityList = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
    },

    getBusinessEquityList() {
      if (this.businessVipState == 1) {
        this.companyEquityList = this.TUPIAN_DETAIL.COMPANY_EQUITY[this.companyVipInfo.type]
      } else {
        this.companyEquityList = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
    },
    tag(stat) {
      tag(stat)
    },
  }
}
</script>

<style lang="scss" scoped>
.common-panel {
  width: 430px;
  background: #FFFFFF;
  border-radius: 14px;
  margin-bottom: 20px;

  .panel-header {
    width: 430px;
    height: 58px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    padding-left: 26px;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 8px;

    .company-name {
      font-size: 16px;
      font-weight: bold;
      line-height: 20px;
      letter-spacing: 1px;
      margin-right: 16px;
    }

    .company-status {
      .company-status-txt {
        font-size: 12px;
        font-weight: bold;
        //color: #865742;
        line-height: 16px;
        letter-spacing: 1px;
      }

      .icon {
        margin-right: 6px;
      }
    }

    .company-buy-btn {
      width: 122px;
      height: 60px;
      @include Position(1, 2, 0, 0);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-weight: bold;
      letter-spacing: 1px;
      text-align: right;

      a {
        color: inherit;
        display: inline-block;
        width: 100%;
        height: 100%;
        padding: 20px 24px 0 0;
        box-sizing: border-box;
      }

    }


  }

  .panel-content {
    padding: 0px 26px 0px;
    box-sizing: border-box;

    .company-equity {
      display: flex;
      flex-wrap: wrap;

      .equity-item {
        width: 50%;
        height: 18px;
        line-height: 18px;
        display: flex;
        align-items: center;
        letter-spacing: 1px;
        margin-bottom: 14px;
        font-size: 13px;
        font-family: MicrosoftYaHei;
        color: #424866;
        line-height: 18px;
        letter-spacing: 1px;
        /*    width: 50%;
            font-size: 13px;
            color: #424866;
            line-height: 18px;
            letter-spacing: 1px;
            //margin-bottom: 14px;
            height: 32px;
            display: flex;
            align-items: flex-start;

            background: pink;
            border: 1px solid #000;
            box-sizing: border-box;*/

        .iconfont {
          margin-right: 8px;
          font-size: 15px;
          position: relative;
          top: 1px;

          &.icon-gou21 {
            color: #35D0BA;
          }

          &.icon-qy-error-circle-fill {
            color: #FF5E69;
          }
        }
      }
    }
  }

  &.company-panel {
    .panel-header {
      background: linear-gradient(180deg, #FFF5EA 0%, rgba(255, 245, 234, 0) 100%);
      color: #865742;

      .company-name {
        color: #865742;
      }

      .company-status {

        display: flex;
        align-items: center;

        .icon {
          @include BgImage(16px, 16px, 'tupian/detail/vip-upgrade-panel/icon_warn.png');
        }

        color: #F1613B;

        &.ON {
          color: #865742;

          .icon {
            @include BgImage(16px, 16px, 'tupian/detail/vip-upgrade-panel/icon_company.png');
          }
        }
      }

      .company-buy-btn {
        @include BgImage(122px, 60px, 'tupian/detail/vip-upgrade-panel/company.png');

        @include ElementHover('', '') {
          @include BgImage(122px, 60px, 'tupian/detail/vip-upgrade-panel/company@hover.png');
        }
      }
    }
  }

  &.business-panel {
    .panel-header {
      background: linear-gradient(180deg, #F6F6FF 0%, rgba(246, 246, 255, 0) 100%);
      color: #596080;

      .company-name {
        color: #596080;
      }

      .company-status {
        color: #596080;

        display: flex;
        align-items: center;

        .icon {
          @include BgImage(16px, 16px, 'tupian/detail/vip-upgrade-panel/icon_warn.png');
        }

        color: #F1613B;

        &.ON {
          color: #596080;

          .icon {
            @include BgImage(16px, 16px, 'tupian/detail/vip-upgrade-panel/icon_business.png');
          }
        }
      }

      .company-buy-btn {
        @include BgImage(122px, 60px, 'tupian/detail/vip-upgrade-panel/business.png');

        @include ElementHover('', '') {
          @include BgImage(122px, 60px, 'tupian/detail/vip-upgrade-panel/business@hover.png');
        }
      }
    }
  }

}
</style>
